import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			padding: '0.75rem',
			width: '100%',
			height: 'auto',
			lineHeight: '1rem',
			justifyContent: 'flex-start',
			// to override RUP btn style
			border: 'none !important',
			'&:active': {
				backgroundColor: Colors.neutral300
			},
			'& svg': {
				width: '1rem',
				height: '1rem',
				marginRight: '0.25rem'
			}
		},
		selectedItem: {
			color: `${Colors.primary500} !important`
		},
		unselectedItem: {
			paddingLeft: '2rem'
		}
	})
);

export interface IDropdownRadioGroupButtonProps {
	checkIcon: string;
	selected?: boolean;
	onSelect: () => void;
	label: string;
	testId?: string;
	controlledBy?: string;
}

const DropdownRadioGroupButton: React.FunctionComponent<IDropdownRadioGroupButtonProps> = props => {
	const classes = useStyles();

	return (
		<button
			onClick={props.onSelect}
			type="button"
			className={clsx(
				classes.root,
				'rup-btn--text rup-btn--neutral',
				props.selected ? classes.selectedItem : classes.unselectedItem
			)}
			data-test-id={props.testId ?? 'btn'}
			data-controlled-by={props.controlledBy || 'self'}
		>
			{props.selected && <span dangerouslySetInnerHTML={{ __html: props.checkIcon }}></span>}
			{props.label}
		</button>
	);
};

export default DropdownRadioGroupButton;
